import Image from 'next/image'
import React from 'react'

import { cn } from '@/_lib/utils'

import { IGalleryImage } from './gallery.types'

interface IAGalleryImageProps extends IGalleryImage {
	index?: number
}

const AGalleryImage: React.FC<IAGalleryImageProps> = ({
	url,
	alt,
	caption,
	widthType,
	index = 0,
	...imageProps
}) => {
	const getWidthClass = (index: number, customWidthType?: string) => {
		if (customWidthType) return customWidthType
		const widthsType = ['uwide', 'wide', '']
		return widthsType[index % widthsType.length]
	}

	const widthClass = getWidthClass(index, widthType)

	// Dynamické sizes podľa šírky obrázka
	const getSizes = () => {
		if (widthClass === 'uwide') {
			return '(max-width: 640px) calc(100vw - 64px), (max-width: 1025px) 650px, 780px'
		}
		if (widthClass === 'wide') {
			return '(max-width: 640px) calc(100vw - 64px), (max-width: 1025px) 500px, 650px'
		}
		return '(max-width: 640px) calc(100vw - 64px), (max-width: 1025px) 350px, 428px'
	}

	return (
		<span className={cn('item_gal relative block', widthClass)}>
			<Image
				src={url}
				alt={alt || caption || 'Ilustračná fotografia'}
				fill
				sizes={getSizes()}
				className='object-cover'
				priority={index < 3}
				unoptimized={true}
				{...imageProps}
			/>
		</span>
	)
}

export default AGalleryImage
